import { Grid } from "@mui/material";
import {
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { doctoralRequests } from "api/doctoralApi";
import { urlValidator } from "utils/validations";

const SaveForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <ReferenceInput
          source="higherEducationFieldId"
          reference={doctoralRequests.getHigherEducationFieldsSelect()}
        >
          <AutocompleteInput
            label="Област на висше образование"
            optionText={record => record?.name ?? ""}
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={6}>
        <ReferenceInput
          source="doctoralProgramId"
          reference={doctoralRequests.getDoctoralProgramsSelect()}
        >
          <AutocompleteInput
            label="Докторантска програма"
            optionText={record => record?.name ?? ""}
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={4}>
        <ReferenceInput
          source="professionalDirectionId"
          reference={administrationRequests.getProfessionalDirectionsSelect()}
        >
          <AutocompleteInput
            label="Професионално направление"
            optionText="nameBg"
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={4}>
        <ReferenceInput
          source="departmentId"
          reference={administrationRequests.getDepartmentsSelect()}
        >
          <AutocompleteInput
            label="Катедра"
            optionText="name"
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={4}>
        <ReferenceInput
          source="studyTypeId"
          reference={doctoralRequests.getDoctoralStudyTypesSelect()}
        >
          <AutocompleteInput
            label="Форма на обучение"
            optionText="name"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={6}>
        <ReferenceInput
          source="doctoralDisciplineId"
          reference={doctoralRequests.getDoctoralDisciplinesSelect()}
        >
          <AutocompleteInput
            label="Изпит (дисциплина)"
            optionText={r => r?.name ?? ""}
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Линк към конспекта по дисциплина"
          source="disciplineConspectLink"
          validate={[required(), urlValidator]}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumberInput
          label="Брой места"
          source="seatCount"
          min={1}
          step={1}
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ReferenceInput
          source="instructionLanguageId"
          reference={administrationRequests.getInstructionLanguagesSelect()}
        >
          <SelectInput
            label="Език на обучение"
            validate={required()}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={6}>
        <NumberInput
          label="Година"
          source="year"
          min={2000}
          step={1}
          validate={required()}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
